import { DbLoadProductList } from "../../../data/usecases/load-product-list";
import { DbLoadReceiptCheck } from "../../../data/usecases/load-receipt-check";
import { LoadProductList } from "../../../domain/usecases/load-product-list";
import { LoadReceiptCheck } from "../../../domain/usecases/load-receipt-check";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl, makeAxiosHttpClient } from "../http";

export const makeDbLoadReceiptCheck = (): LoadReceiptCheck =>
  new DbLoadReceiptCheck(
    makeApiUrl("/receipt/check"),
    makeAuthorizeHttpClientDecorator()
  );
